var TEMPLATE_URL = require('./accuracy.window.html');
angular.module('ikeweb.spike.measure').directive('accuracyWindow', ['photogrammetryToolKit',

    function(photogrammetryToolKit) {

        var Measurement = photogrammetryToolKit.Measurement;

        return {
            restrict: 'E',
            replace: true,
            scope: {
                imageElement: '='
            },
            templateUrl: TEMPLATE_URL,
            link: function($scope, $element) {

                function slideTo(x, y) {
                    $element.css({
                        /* 8 & 10  */
                        'background-position': (($element.width() / 2) - x) + 'px ' + (($element.height() / 2) - y) + 'px'
                    });
                }

                function update(coords) {
                    slideTo(coords.x, coords.y);
                }

                $scope.$watch('imageElement', function(imageElement) {

                    if (!imageElement) {
                        return;
                    }

                    $element.css({
                        'background-image': 'url(' + imageElement.src + ')'
                    });

                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.STARTED, update);
                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.UPDATED, update);
                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.FINISHED, update);
                    slideTo(imageElement.naturalWidth / 2, imageElement.naturalHeight / 2);
                });
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/accuracy-window/accuracy.window.directive.js
// module id = 576
// module chunks = 0